var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 318,
    viewBox: "0 0 559 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.964 182.043C516.229 175.26 510.165 170.523 503.212 170.523H453.716C446.423 170.523 440.157 175.726 438.762 182.931L437.439 189.779C442.694 185.987 448.534 183.87 454.685 183.87H479.107C502.186 183.87 520.891 213.619 520.891 250.312H538.057H535.405L517.971 182.036L517.964 182.043Z",
    fill: "#E9EEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.9 250.319H402.622L385.189 182.043C383.454 175.26 377.39 170.523 370.437 170.523H320.941C313.648 170.523 307.381 175.726 305.986 182.931L304.555 190.325C310.005 186.191 316.098 183.877 322.538 183.877H346.961C370.039 183.877 388.745 213.627 388.745 250.319H412.9Z",
    fill: "#E9EEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.239 0.596877C222.595 0.596877 212.108 7.68502 207.699 18.5428L176.475 95.4572L102.737 114.786C96.181 116.503 91.0492 121.641 89.3073 128.234L73.3267 188.782H258.445L274.028 129.734C276.031 122.143 281.719 116.096 289.142 113.68L345.006 95.4499L376.23 18.5356C380.639 7.68502 391.126 0.5896 402.77 0.5896H234.232L234.239 0.596877Z",
    fill: "#A3C5EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M545.584 241.463L511.924 24.9985C509.742 10.9532 497.722 0.597565 483.599 0.597565H402.777C391.133 0.597565 380.646 7.68571 376.237 18.5435L345.013 95.4579L289.149 113.688C281.733 116.111 276.038 122.151 274.036 129.741L255.843 198.68C254.86 202.413 255.034 206.365 256.342 209.996L266.389 237.861C269.085 245.342 270.501 250.327 278.408 250.327H283.367C288.939 250.327 293.739 246.346 294.801 240.838L305.982 182.939C307.377 175.734 313.644 170.531 320.937 170.531H370.433C377.386 170.531 383.457 175.269 385.185 182.051L402.618 250.327H416.134C421.707 250.327 426.506 246.346 427.569 240.838L438.75 182.939C440.145 175.734 446.412 170.531 453.704 170.531H503.2C510.154 170.531 516.225 175.269 517.952 182.051L535.386 250.327H538.039C542.715 250.327 546.293 246.121 545.57 241.471L545.584 241.463Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1348 204.588C70.236 206.422 70.5973 208.248 71.2262 209.995L81.2728 237.86C83.9688 245.341 91.0304 250.326 98.9376 250.326H278.411C270.504 250.326 269.087 245.341 266.391 237.86L256.345 209.995C255.716 208.248 255.355 206.422 255.253 204.588H70.1348Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 250.32C123.5 287.012 142.205 316.762 165.284 316.762C188.362 316.762 207.068 287.012 207.068 250.32H123.507H123.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.502 250.32H99.0791C99.0791 287.012 117.785 316.762 140.863 316.762H165.286C142.207 316.762 123.502 287.012 123.502 250.32Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.027 250.32C148.027 265.471 155.754 277.763 165.28 277.763C174.806 277.763 182.533 265.479 182.533 250.32H148.02H148.027Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M346.959 316.762C370.036 316.762 388.743 287.014 388.743 250.319C388.743 213.624 370.036 183.877 346.959 183.877C323.882 183.877 305.175 213.624 305.175 250.319C305.175 287.014 323.882 316.762 346.959 316.762Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M346.966 277.763C356.495 277.763 364.219 265.476 364.219 250.32C364.219 235.164 356.495 222.877 346.966 222.877C337.438 222.877 329.713 235.164 329.713 250.32C329.713 265.476 337.438 277.763 346.966 277.763Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M305.188 250.319C305.188 213.627 323.893 183.877 346.972 183.877H322.549C316.109 183.877 310.016 186.191 304.566 190.332C304.566 190.332 296.095 233.734 294.809 240.837C293.522 247.94 287.313 250.327 283.374 250.327H280.765C280.765 287.019 299.47 316.769 322.549 316.769H346.972C323.893 316.769 305.188 287.019 305.188 250.327V250.319Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.114 316.762C502.19 316.762 520.898 287.014 520.898 250.319C520.898 213.624 502.19 183.877 479.114 183.877C456.037 183.877 437.33 213.624 437.33 250.319C437.33 287.014 456.037 316.762 479.114 316.762Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M479.113 277.763C488.642 277.763 496.366 265.476 496.366 250.32C496.366 235.164 488.642 222.877 479.113 222.877C469.585 222.877 461.86 235.164 461.86 250.32C461.86 265.476 469.585 277.763 479.113 277.763Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M437.324 250.319C437.324 213.627 456.03 183.877 479.108 183.877H454.685C448.245 183.877 442.152 186.191 436.703 190.332C436.703 190.332 428.232 233.734 426.945 240.837C425.658 247.94 419.45 250.327 415.511 250.327H412.901C412.901 287.019 431.607 316.769 454.685 316.769H479.108C456.03 316.769 437.324 287.019 437.324 250.327V250.319Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.041 174.751H97.5969C99.8231 174.751 101.775 173.244 102.346 171.075L111.937 134.718C112.768 131.581 110.412 128.503 107.188 128.503H89.3138L77.041 174.758V174.751Z",
    fill: "#E9EEF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.437 153.327L128.923 158.123C131.836 163.727 137.596 167.242 143.877 167.242H168.011L171.683 153.327H126.437Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.461 139.042H119.019L126.442 153.327H171.688L175.461 139.042Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.598 160.59L221.134 153.327H171.689L168.017 167.242H202.204C207.452 167.242 212.403 164.782 215.598 160.59Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.139 153.327L232.017 139.042H175.466L171.693 153.327H221.139Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.157 174.75H244.232C240.055 174.75 237.019 170.769 238.089 166.708L246.914 133.254C247.651 130.453 250.174 128.495 253.057 128.495H274.351L262.157 174.75Z",
    fill: "#E9EEF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M192.395 89.7655L221.314 18.5421H361.425L332.506 89.7655H192.395Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.211 235.684C234.026 233.493 231.742 232.132 229.27 232.132H113.502C108.312 232.132 105.053 237.758 107.604 242.306L112.1 250.318H243.147L235.204 235.684H235.211Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5199 227.171C96.871 227.171 100.398 223.619 100.398 219.238C100.398 214.857 96.871 211.306 92.5199 211.306C88.1688 211.306 84.6416 214.857 84.6416 219.238C84.6416 223.619 88.1688 227.171 92.5199 227.171Z",
    fill: "#F39200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M240.655 227.171C245.006 227.171 248.533 223.619 248.533 219.238C248.533 214.857 245.006 211.306 240.655 211.306C236.304 211.306 232.777 214.857 232.777 219.238C232.777 223.619 236.304 227.171 240.655 227.171Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M393.134 18.5421L364.223 89.7655H445.03L434.275 18.5421H393.134Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M493.256 18.5421H434.277L445.032 89.7655H504.329L493.256 18.5421Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3301 188.79L70.7209 198.68C70.2077 200.615 70.0198 202.609 70.1282 204.589H255.247C255.138 202.609 255.334 200.615 255.84 198.68L258.449 188.79H73.3301Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M185.386 198.009H133.664V222.883H185.386V198.009Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M346.959 316.762C370.036 316.762 388.743 287.014 388.743 250.319C388.743 213.624 370.036 183.877 346.959 183.877C323.882 183.877 305.175 213.624 305.175 250.319C305.175 287.014 323.882 316.762 346.959 316.762Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M280.754 250.318C280.754 287.01 299.46 316.76 322.538 316.76H346.961",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M346.963 183.877H322.54C316.1 183.877 310.007 186.191 304.558 190.332",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M346.957 277.763C356.486 277.763 364.21 265.476 364.21 250.32C364.21 235.164 356.486 222.877 346.957 222.877C337.429 222.877 329.704 235.164 329.704 250.32C329.704 265.476 337.429 277.763 346.957 277.763Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M207.068 250.318C207.068 287.01 188.362 316.76 165.284 316.76C142.205 316.76 123.5 287.01 123.5 250.318",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0715 250.318C99.0715 287.01 117.777 316.76 140.856 316.76H165.278",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.535 250.318C182.535 265.469 174.808 277.761 165.282 277.761C155.756 277.761 148.029 265.477 148.029 250.318",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M496.373 310.84C491.11 314.643 485.263 316.762 479.105 316.762C456.028 316.762 437.321 287.014 437.321 250.319C437.321 213.624 456.028 183.877 479.105 183.877C499.652 183.877 516.436 207.461 519.934 238.534",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M412.894 250.318C412.894 287.01 431.599 316.76 454.678 316.76H479.101",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M479.1 183.877H454.678C448.527 183.877 442.694 185.987 437.432 189.779",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M479.104 277.763C488.633 277.763 496.357 265.476 496.357 250.32C496.357 235.164 488.633 222.877 479.104 222.877C469.576 222.877 461.851 235.164 461.851 250.32C461.851 265.476 469.576 277.763 479.104 277.763Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2184 209.996C69.9102 206.365 69.7367 202.413 70.7197 198.68L89.3024 128.235C91.0443 121.642 96.176 116.504 102.732 114.786L176.47 95.4579L207.694 18.5435C212.103 7.68571 222.59 0.597565 234.234 0.597565H483.594C497.169 0.597565 508.802 10.1658 511.622 23.3818M402.621 250.327L385.187 182.051C383.46 175.269 377.388 170.531 370.435 170.531H320.939C313.646 170.531 307.38 175.734 305.985 182.939L294.803 240.838C293.741 246.346 288.942 250.327 283.369 250.327H98.9298C93.0542 250.327 87.6455 247.575 84.1479 243.091H0.677734M518.124 65.318L539.012 199.331",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3063 128.503H107.181C110.404 128.503 112.761 131.581 111.929 134.718L102.338 171.076C101.767 173.244 99.8155 174.751 97.5893 174.751H77.0334",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M175.36 139.412L168.017 167.241",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.707 128.503H253.057C250.173 128.503 247.651 130.453 246.913 133.262L238.088 166.716C237.019 170.777 240.062 174.758 244.232 174.758H262.157",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M402.768 0.597565C391.124 0.597565 380.637 7.68571 376.228 18.5435L345.004 95.4579L289.14 113.688C281.724 116.111 276.029 122.151 274.027 129.741L255.834 198.68C254.851 202.413 255.025 206.365 256.333 209.996L266.38 237.861C269.075 245.342 270.492 250.327 278.399 250.327",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.395 89.7655L221.314 18.5421H361.425L332.506 89.7655H192.395Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M384.88 38.8763L393.134 18.5421H493.254L495.471 36.1413M558 123.66H469.567C467.357 123.66 465.567 121.869 465.567 119.66V75.9597C465.567 73.7505 463.776 71.9597 461.567 71.9597H371.451L364.223 89.7655H504.327L498.19 52.5511",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M388.754 250.319H416.155C421.734 250.319 426.526 246.338 427.589 240.829L438.77 182.93C440.165 175.726 446.432 170.522 453.725 170.522H503.221C510.174 170.522 516.238 175.26 517.973 182.042L528.094 221.212",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M185.377 198.009H133.655V222.883H185.377V198.009Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M133.658 204.588H70.1182",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M255.234 204.588H185.377",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M258.445 188.79H73.3267",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M232.011 139.042H119.019L128.928 158.123C131.841 163.726 137.601 167.241 143.882 167.241H202.203C207.451 167.241 212.402 164.782 215.597 160.59L232.018 139.042H232.011Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M221.128 153.325H126.437",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 250.318L107.604 242.306C105.053 237.758 108.312 232.132 113.502 232.132H229.27C231.749 232.132 234.026 233.493 235.211 235.684L243.154 250.318",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5199 227.171C96.871 227.171 100.398 223.619 100.398 219.238C100.398 214.857 96.871 211.306 92.5199 211.306C88.1688 211.306 84.6416 214.857 84.6416 219.238C84.6416 223.619 88.1688 227.171 92.5199 227.171Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M240.655 227.171C245.006 227.171 248.533 223.619 248.533 219.238C248.533 214.857 245.006 211.306 240.655 211.306C236.304 211.306 232.777 214.857 232.777 219.238C232.777 223.619 236.304 227.171 240.655 227.171Z",
    fill: "#F39200",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M434.268 18.5421L445.023 89.7655",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M440.252 107.916H423.664",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M500.764 107.916H484.169",
    stroke: "#6F7C87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.a71c3c30.svg";
export { ForwardRef as ReactComponent };